import { Routes } from '@angular/router';
import { HistorialLlamanosComponent } from './pages/historial-llamanos/historial-llamanos.component';
import { HistorialSiniestroComponent } from './pages/historial-siniestro/historial-siniestro.component';
import { MantenedorComponent } from './pages/mantenedor/mantenedor.component';
import { LlamanosComponent } from './pages/llamanos/llamanos.component';
import { SiniestrosComponent } from './pages/siniestros/siniestros.component';

export const routes: Routes = [
  { path: 'historial-llamanos', component: HistorialLlamanosComponent },
  { path: 'historial-siniestro', component: HistorialSiniestroComponent },
  { path: 'mantenedor', component: MantenedorComponent },
  { path: 'llamanos', component: LlamanosComponent },
  { path: 'siniestro', component: SiniestrosComponent },
];
